import api from '@/js/services/api';

export default {

    //get

    fetchEventsType() {
        return api().get(`/events/types/get`);
    },

    getBookedEvents(artist_id) {
        return api().get(`/events/${artist_id}/booked/get`);
    },

    fetchEvents(artist_id, year) {
        return api().get(`/events/${artist_id}/get?year=${encodeURIComponent(year)}`);
    },

    createNewEvent(artist_id, info) {
        return api().put(`/events/${artist_id}/create`, info);
    },

    updateGeneralArtistInfo(id, info) {
        return api().put(`/artist/${id}/update`, info);
    },

    deleteEvent(event_id) {
        return api().delete(`/events/${event_id}/delete`);
    }
}
